/* import __COLOCATED_TEMPLATE__ from './start-timing-record-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { use } from 'ember-resources';
import { socketRecordTable } from 'bullitttime-embercomponents/utils/socket-record-table-resource';

export default class StartTimingAssociationTableComponent extends Component
{
	@tracked timingRecordForContextMenu = null;

	@service ajax;
	@service socketGuru;

	// The table rebuilds (old one torn down, new one started) whenever a tracked
	// read in this thunk changes. The dependency is named on the first line.
	@use startRecords = socketRecordTable(() =>
	{
		const { event } = this.args;
		return {
			socketGuru: this.socketGuru,
			ajax: this.ajax,
			channels: 'startAssociationRecord',
			endpoint: () => event ? `/events/${event.id}/startAssociationRecords` : null,
			transform: (record) => this.transformRecord(record),
			sort: this.sortFn,
		};
	});

	constructor()
	{
		super(...arguments);

		// entryStatusChange is a cross-cutting patch (keyed by EntryId, not the
		// record id), so it rides on its own listener rather than the table's.
		this._boundEntryStatus = this._handleEntryStatus.bind(this);
		this.socketGuru.events.addEventListener('newEvent', this._boundEntryStatus);
	}

	willDestroy()
	{
		this.socketGuru.events.removeEventListener('newEvent', this._boundEntryStatus);
		super.willDestroy();
	}

	transformRecord(record)
	{
		if(!this.args.event || record.eventId != this.args.event.id)
		{
			return null;
		}
		record.color = this.recordColor(record);
		return record;
	}

	sortFn(a,b)
	{
		var aTime = a.startImpulseTime || a.assignedStartTime;
		var bTime = b.startImpulseTime || b.assignedStartTime;
		if(aTime == undefined)
			aTime = null;
		if(bTime == undefined)
			bTime = null;

		//sort on id to keep a consistent order for wave start groups
		//records are guarenteed not to have the same id
		if(aTime == bTime)
		{
			return a.id>b.id ? -1 : 1;
		}

		return aTime>bTime ? -1 : aTime<bTime ? 1 : 0 ;
	}

	recordColor(record)
	{
		if(record.entryStatus === 'DNS')
		{
			return "table-danger";
		}
		if(record.participatesInAutoAssociation == false)
		{
			return "table-warning";
		}
	}

	_handleEntryStatus(event)
	{
		const { eventName, data } = event.detail;
		if(eventName != "entryStatusChange")
		{
			return;
		}
		var parsed = JSON.parse(data);
		if(parsed.type != 'UPDATE')
		{
			return;
		}
		var entryData = JSON.parse(parsed.row);
		var entryId = entryData.id;
		var newStatus = entryData.status;

		this.startRecords.updateWhere(
			(record) => record.EntryId == entryId,
			(record) =>
			{
				var updated = { ...record, entryStatus: newStatus };
				updated.color = this.recordColor(updated);
				return updated;
			}
		);
	}

	@action
	click()
	{
		this.timingRecordForContextMenu = null;
		const menu = document.getElementById("context-menu");
		menu.style.display = "none";
		menu.classList.add("hide");
	}

	@action
	startTimeClicked(timingRecord)
	{
		if(this.timingRecordForContextMenu == null)
			this.args.startTimeSelectAction(timingRecord);
	}

	@action
	startImpulseClicked(timingRecord)
	{
		if(this.timingRecordForContextMenu == null)
			this.args.startImpulseSelectAction(timingRecord);
	}

	@action
	contextMenu(timingRecord,browserEvent)
	{
		browserEvent.preventDefault();

		this.timingRecordForContextMenu = timingRecord;

		const menu = document.getElementById("context-menu");
		menu.querySelector("#auto").classList.toggle("active", timingRecord.participatesInAutoAssociation);
		const tableRect = document.getElementById("startTimingRecordTable").getBoundingClientRect();
		menu.style.display = "block";
		menu.style.top = (browserEvent.clientY - (tableRect.top + window.scrollY) - 20) + "px";
		menu.style.left = (browserEvent.clientX - (tableRect.left + window.scrollX)) + "px";
		menu.classList.add("show");

		return false;
	}

	@action
	contextMenuAuto()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}
		if(tr.participatesInAutoAssociation)
		{
			this.ajax.request("/start-timing-records/"+tr.id+"/removeFromAutoAssociation").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		else
		{
			this.ajax.request("/start-timing-records/"+tr.id+"/addToAutoAssociation").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		this.click();
	}

	@action
	contextMenuDisassociate()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}

		if(tr.startImpulseId == null)
		{
			alert('record has no start impulse');
			return;
		}
		if(tr.assignedStartTime == null)
		{
			alert('record has no assigned start time');
			return;
		}

		this.ajax.request("/start-timing-records/"+tr.id+"/disassociateStartImpulse").then(function(response)
		{
			if(response.error != null)
				alert(response.error);
		});
		this.click();
	}
}
